let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f0PEA")).then(() => parcelRequire('a0pbo'));